// src/components/calendar/eventRenderer.js
import { getTitleColor } from "../../utils/eventColors";

export default function EventRenderer({ eventInfo }) {
  const { title, extendedProps } = eventInfo.event;

  const {
    event_type,
    description,
    primary_technician,
    additional_technicians,
    property,
  } = extendedProps;

  const baseClass =
    "p-2 border rounded cursor-pointer font-sans w-full overflow-hidden";

  const generalEvents = [
    "event",
    "travel",
    "office",
    "rest",
    "training",
    "no_job",
  ];

  // Birthday
  if (event_type === "birthday") {
    return (
      <div className={`${baseClass} ${getTitleColor(title, event_type)}`}>
        <div className="font-semibold truncate">{title}</div>
        <div className="text-xs text-gray-600 truncate">Birthday</div>
      </div>
    );
  }

  // Holiday
  if (event_type === "holiday") {
    return (
      <div className={`${baseClass} ${getTitleColor(title, event_type)}`}>
        <div className="font-semibold text-sm truncate">{title}</div>
      </div>
    );
  }

  // General events
  if (generalEvents.includes(event_type)) {
    return (
      <div
        className={`${baseClass} ${getTitleColor(
          title,
          event_type,
          primary_technician
        )}`}
      >
        <div className="font-semibold truncate">{title}</div>
        <div className="text-xs text-gray-700 truncate">Technician: {primary_technician || "-"}</div>
      </div>
    );
  }

  // Work events
  return (
    <div className={`${baseClass} ${getTitleColor(title, event_type)}`}>
      <div className="font-semibold truncate">{description || title}</div>
      <div className="text-xs text-gray-700 truncate">Property #: {property || "-"}</div>
      <div className="text-xs text-gray-700 truncate">Technician: {primary_technician || "-"}</div>
      <div className="text-xs text-gray-600 truncate">
        Additional Technician: {additional_technicians || "-"}
      </div>
    </div>
  );
}